export const YARD_CONSOLE_SERVICE = "YardConsoleService";
export const YARD_360_SERVICE = "Yard360Service";
export const RYC_WEBSOCKET = "RycWebsocket";
export const RYC_SERVICE = "RycService";
export const SESAME_GATE_SERVICE = "SesameGateService";

// HERE Maps configuration
export const HERE_MAPS_CONFIG = {
  baseUrl: "https://maps.hereapi.com/v3/base/mc",
} as const;

export interface ApiConfig {
  name: string;
  resource: string;
  service: string;
}

export const APIS = {
  IsFeatureEnabled: {
    name: "IsFeatureEnabled",
    resource: "/isFeatureEnabled",
    service: YARD_CONSOLE_SERVICE,
  },
  ListSupportedYardIdentifiers: {
    name: "ListSupportedYardIdentifiers",
    resource: "/listSupportedYardIdentifiers",
    service: YARD_CONSOLE_SERVICE,
  },
  UpdateEquipmentLocation: {
    name: "UpdateEquipmentLocation",
    resource: "/updateEquipmentLocation",
    service: YARD_CONSOLE_SERVICE,
  },
  ListEligibleLocationsForEquipment: {
    name: "ListEligibleLocationsForEquipment",
    resource: "/listEligibleLocationsForEquipment",
    service: YARD_CONSOLE_SERVICE,
  },
  ListEquipmentOwners: {
    name: "ListEquipmentOwners",
    resource: "/listEquipmentOwners",
    service: YARD_CONSOLE_SERVICE,
  },
  GetWranglingReport: {
    name: "GetWranglingReport",
    resource: "/getWranglingReport",
    service: YARD_360_SERVICE,
  },
  GetEquipmentReport: {
    name: "GetEquipmentReport",
    resource: "/getEquipmentReport",
    service: YARD_360_SERVICE,
  },
  UpdateEquipmentOtherInfo: {
    name: "UpdateEquipmentOtherInfo",
    resource: "/updateEquipmentOtherInfo",
    service: YARD_CONSOLE_SERVICE,
  },
  QueryYardGraph: {
    name: "QueryYardGraph",
    resource: "/queryYardGraph",
    service: YARD_CONSOLE_SERVICE,
  },
  GetYardVisits: {
    name: "GetYardVisits",
    resource: "/getYardVisits",
    service: YARD_360_SERVICE,
  },
  GetYardJobs: {
    name: "GetYardJobs",
    resource: "/getYardJobs",
    service: YARD_360_SERVICE,
  },
  GetYardMap: {
    name: "GetYardMap",
    resource: "/getYardMap",
    service: YARD_360_SERVICE,
  },
  CreateYardJob: {
    name: "CreateYardJob",
    resource: "/createYardJob",
    service: YARD_360_SERVICE,
  },
  GetYardAlerts: {
    name: "GetYardAlerts",
    resource: "/getYardAlerts",
    service: YARD_360_SERVICE,
  },
  GetGateEvents: {
    name: "GetGateEvents",
    resource: "/getGateEvents",
    service: YARD_360_SERVICE,
  },
  CompleteYardAlert: {
    name: "CompleteYardAlert",
    resource: "/completeYardAlert",
    service: YARD_360_SERVICE,
  },
  DismissYardAlert: {
    name: "DismissYardAlert",
    resource: "/dismissYardAlert",
    service: YARD_360_SERVICE,
  },
  GetYardMetrics: {
    name: "GetYardMetrics",
    resource: "/getYardMetrics",
    service: YARD_360_SERVICE,
  },
  GetYardMoves: {
    name: "GetYardMoves",
    resource: "/getYardMoves",
    service: YARD_360_SERVICE,
  },
  GetDriverVisitEvents: {
    name: "GetDriverVisitEvents",
    resource: "/getDriverVisitEvents",
    service: YARD_360_SERVICE,
  },
  GetGateSensorEventsByYardAndTimeRange: {
    name: "GetGateSensorEventsByYardAndTimeRange",
    resource: "/getGateSensorEventsByYardAndTimeRange",
    service: YARD_360_SERVICE,
  },
  BookVR: {
    name: "BookVR",
    resource: "/bookVR",
    service: YARD_360_SERVICE,
  },
  GetYardDomainEvents: {
    name: "GetYardDomainEvents",
    resource: "/getYardDomainEvents",
    service: YARD_360_SERVICE,
  },
  // Owner Configuration APIs - Sesame Service
  GetEquipmentOwners: {
    name: "GetEquipmentOwners",
    resource: "/SesameService/",
    service: SESAME_GATE_SERVICE,
  },
  GetEquipmentOwnerByCode: {
    name: "GetEquipmentOwnerByCode",
    resource: "/SesameService/",
    service: SESAME_GATE_SERVICE,
  },
  CreateEquipmentOwner: {
    name: "CreateEquipmentOwner",
    resource: "/SesameService/",
    service: SESAME_GATE_SERVICE,
  },
  UpdateEquipmentOwner: {
    name: "UpdateEquipmentOwner",
    resource: "/SesameService/",
    service: SESAME_GATE_SERVICE,
  },
  CreateOrUpdateEquipmentOwners: {
    name: "CreateOrUpdateEquipmentOwners",
    resource: "/SesameService/",
    service: SESAME_GATE_SERVICE,
  },
  UpdateEquipmentCoreInfo: {
    name: "UpdateEquipmentCoreInfo",
    resource: "/updateEquipmentCoreInfo",
    service: YARD_CONSOLE_SERVICE,
  },
  // RYTE Tracker APIs
  GetYardGoals: {
    name: "GetYardGoals",
    resource: "/getYardGoals",
    service: YARD_360_SERVICE,
  },
  GetRecommendedEquipment: {
    name: "GetRecommendedEquipment",
    resource: "/getRecommendedEquipment",
    service: YARD_360_SERVICE,
  },
  OverrideRecommendation: {
    name: "OverrideRecommendation",
    resource: "/overrideRecommendation",
    service: YARD_360_SERVICE,
  },
  DeselectEquipmentForHaulAction: {
    name: "DeselectEquipmentForHaulAction",
    resource: "/deselectEquipmentForHaulAction",
    service: YARD_360_SERVICE,
  },
  CreateYardGoal: {
    name: "CreateYardGoal",
    resource: "/createYardGoal",
    service: YARD_360_SERVICE,
  },
  UpdateYardGoal: {
    name: "UpdateYardGoal",
    resource: "/updateYardGoal",
    service: YARD_360_SERVICE,
  },
  RequestCancelYardGoal: {
    name: "RequestCancelYardGoal",
    resource: "/requestCancelYardGoal",
    service: YARD_360_SERVICE,
  },
  RequestHoldYardGoal: {
    name: "RequestHoldYardGoal",
    resource: "/requestHoldYardGoal",
    service: YARD_360_SERVICE,
  },
  RequestReleaseYardGoal: {
    name: "RequestReleaseYardGoal",
    resource: "/requestReleaseYardGoal",
    service: YARD_360_SERVICE,
  },
  FetchRyteAppointments: {
    name: "FetchRyteAppointments",
    resource: "/getYardAppointments",
    service: YARD_360_SERVICE,
  },
  GetYardEvents: {
    name: "GetYardEvents",
    resource: "/getYardEvents",
    service: YARD_360_SERVICE,
  },
  // Hostler Pool APIs
  GetHostlerPool: {
    name: "GetHostlerPool",
    resource: "/getHostlerPool",
    service: YARD_360_SERVICE,
  },
  AddHostlerVehicle: {
    name: "AddHostlerVehicle",
    resource: "/addHostlerVehicle",
    service: YARD_360_SERVICE,
  },
  RemoveHostlerVehicle: {
    name: "RemoveHostlerVehicle",
    resource: "/removeHostlerVehicle",
    service: YARD_360_SERVICE,
  },
  ForceUnpairHostler: {
    name: "ForceUnpairHostler",
    resource: "/forceUnpairHostler",
    service: YARD_360_SERVICE,
  },
  CheckManagerOverridePermission: {
    name: "CheckManagerOverridePermission",
    resource: "/checkManagerOverridePermission",
    service: YARD_CONSOLE_SERVICE,
  },
  GetAllFleetEquipment: {
    name: "GetAllFleetEquipment",
    resource: "/getAllFleetEquipment",
    service: YARD_CONSOLE_SERVICE,
  },
  GetEquipmentById: {
    name: "GetEquipmentById",
    resource: "/getEquipmentById",
    service: YARD_CONSOLE_SERVICE,
  },
  AddOperationalCodes: {
    name: "AddOperationalCodes",
    resource: "/addOperationalCodes",
    service: YARD_CONSOLE_SERVICE,
  },
  RemoveOperationalCodes: {
    name: "RemoveOperationalCodes",
    resource: "/removeOperationalCodes",
    service: YARD_CONSOLE_SERVICE,
  },
  AuditRemoveEquipmentFromYard: {
    name: "AuditRemoveEquipmentFromYard",
    resource: "/auditRemoveEquipmentFromYard",
    service: YARD_CONSOLE_SERVICE,
  },
  CancelMove: {
    name: "CancelMove",
    resource: "/cancelMove",
    service: YARD_CONSOLE_SERVICE,
  },
  ReorderMove: {
    name: "ReorderMove",
    resource: "/reorderMove",
    service: YARD_CONSOLE_SERVICE,
  },
  CompleteMove: {
    name: "CompleteMove",
    resource: "/completeMove",
    service: YARD_CONSOLE_SERVICE,
  },
  ListPendingMoves: {
    name: "ListPendingMoves",
    resource: "/listPendingMoves",
    service: YARD_CONSOLE_SERVICE,
  },
  ListSupportedEquipmentTypes: {
    name: "ListSupportedEquipmentTypes",
    resource: "/listSupportedEquipmentTypes",
    service: YARD_CONSOLE_SERVICE,
  },
  GetYardStateWithPendingMoves: {
    name: "GetYardStateWithPendingMoves",
    resource: "/getYardStateWithPendingMoves",
    service: YARD_CONSOLE_SERVICE,
  },
  AuditAddEquipmentToYard: {
    name: "AuditAddEquipmentToYard",
    resource: "/auditAddEquipmentToYard",
    service: YARD_CONSOLE_SERVICE,
  },
  ForceCheckOut: {
    name: "ForceCheckOut",
    resource: "/forceCheckOut",
    service: YARD_CONSOLE_SERVICE,
  },
  EmergencyStatusUpdate: {
    // `name` is sent as the wire `api` header and `resource` is the route;
    // both use the gateway/Coral HTTP URI `emergencyStatusUpdate`, matching
    // YMS. (The SDK operation is EmergencyTrailerHandoverStatusUpdate, but the
    // registered API Gateway route is `/emergencyStatusUpdate`.) (Yard-5864)
    name: "EmergencyStatusUpdate",
    resource: "/emergencyStatusUpdate",
    service: YARD_CONSOLE_SERVICE,
  },
  GetRelayYardHubPermissions: {
    name: "GetRelayYardHubPermissions",
    resource: "/getRelayYardHubPermissions",
    service: YARD_360_SERVICE,
  },
} as const;

export type ApiName = keyof typeof APIS;

/** Sesame Service method names for x-amz-target header */
export const SESAME_METHODS = {
  ListAllCarriers:
    "com.amazon.sesamegateservice.coral.sesame.proxy.SesameServiceProxy.listAllCarriers",
  GetCarrierByCode:
    "com.amazon.sesamegateservice.coral.sesame.proxy.SesameServiceProxy.getCarrierByCode",
  CreateEquipmentOwner:
    "com.amazon.sesamegateservice.coral.sesame.proxy.SesameServiceProxy.createEquipmentOwner",
  UpdateEquipmentOwner:
    "com.amazon.sesamegateservice.coral.sesame.proxy.SesameServiceProxy.updateEquipmentOwner",
  CreateOrUpdateEquipmentOwners:
    "com.amazon.sesamegateservice.coral.sesame.proxy.SesameServiceProxy.createOrUpdateEquipmentOwners",
} as const;

export const ENDPOINTS = {
  USAmazon: {
    test: {
      [YARD_CONSOLE_SERVICE]: "https://7xdrp44p33.execute-api.us-west-2.amazonaws.com/call",
      [YARD_360_SERVICE]: "https://kdupppgya5.execute-api.us-west-2.amazonaws.com/beta",
      [RYC_WEBSOCKET]: "wss://xdsyl5zi2h.execute-api.us-west-2.amazonaws.com/beta/",
      [RYC_SERVICE]: "http://localhost:8888",
      [SESAME_GATE_SERVICE]: "https://sesamegateservice-beta.integ.amazon.com",
    },
    master: {
      [YARD_CONSOLE_SERVICE]: "https://n3c22uu4x7.execute-api.us-east-1.amazonaws.com/call",
      [YARD_360_SERVICE]: "https://fcbu7opy7i.execute-api.us-east-1.amazonaws.com/gamma",
      [RYC_WEBSOCKET]: "wss://p461hbshdg.execute-api.us-east-1.amazonaws.com/gamma/",
      [RYC_SERVICE]: "http://localhost:8888",
      [SESAME_GATE_SERVICE]: "https://sesamegateservice-preprod-na-ext.amazon.com",
    },
    prod: {
      [YARD_CONSOLE_SERVICE]: "https://ii51s3lexd.execute-api.us-east-1.amazonaws.com/call",
      [YARD_360_SERVICE]: "https://amphlex3y5.execute-api.us-east-1.amazonaws.com/prod",
      [RYC_WEBSOCKET]: "wss://mdptb37qe1.execute-api.us-east-1.amazonaws.com/prod/",
      [RYC_SERVICE]: "http://localhost:8888",
      [SESAME_GATE_SERVICE]: "https://sesamegateservice-na-ext.amazon.com",
    },
  },
  EUAmazon: {
    master: {
      [YARD_CONSOLE_SERVICE]: "https://acbv2gw3b1.execute-api.eu-west-1.amazonaws.com/call",
      [YARD_360_SERVICE]: "https://3fm6gnkym7.execute-api.eu-west-1.amazonaws.com/gamma",
      [RYC_WEBSOCKET]: "wss://jkdo08xje3.execute-api.us-east-1.amazonaws.com/gamma/",
      [RYC_SERVICE]: "http://localhost:8888",
      [SESAME_GATE_SERVICE]: "https://sesamegateservice-preprod-eu-ext.amazon.com",
    },
    prod: {
      [YARD_CONSOLE_SERVICE]: "https://jwmjkz3dsd.execute-api.eu-west-1.amazonaws.com/call",
      [YARD_360_SERVICE]: "https://ezermrlh7a.execute-api.eu-west-1.amazonaws.com/prod",
      [RYC_WEBSOCKET]: "wss://h0d9edyf9h.execute-api.eu-west-1.amazonaws.com/prod/",
      [RYC_SERVICE]: "http://localhost:8888",
      [SESAME_GATE_SERVICE]: "https://sesamegateservice-eu-ext.amazon.com",
    },
  },
  JPAmazon: {
    master: {
      [YARD_CONSOLE_SERVICE]: "https://s6ncenhie1.execute-api.us-west-2.amazonaws.com/call",
      [YARD_360_SERVICE]: "https://j9thkktrid.execute-api.us-west-2.amazonaws.com/gamma",
      [RYC_WEBSOCKET]: "wss://gxugggu3fe.execute-api.us-west-2.amazonaws.com/gamma/",
      [RYC_SERVICE]: "http://localhost:8888",
      [SESAME_GATE_SERVICE]: "https://sesamegateservice-preprod-jp-ext.amazon.com",
    },
    prod: {
      [YARD_CONSOLE_SERVICE]: "https://vs32e0yvra.execute-api.us-west-2.amazonaws.com/call",
      [YARD_360_SERVICE]: "https://59s8c2gnka.execute-api.us-west-2.amazonaws.com/prod",
      [RYC_WEBSOCKET]: "wss://hgcls1hqw9.execute-api.us-west-2.amazonaws.com/prod/",
      [RYC_SERVICE]: "http://localhost:8888",
      [SESAME_GATE_SERVICE]: "https://sesamegateservice-jp-ext.amazon.com",
    },
  },
} as const;
